export let ForecastAmountSettingOptions;
(function (ForecastAmountSettingOptions) {
  ForecastAmountSettingOptions["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
  ForecastAmountSettingOptions["WEIGHTED_AMOUNT"] = "WEIGHTED_AMOUNT";
  ForecastAmountSettingOptions["FORECAST_AMOUNT"] = "FORECAST_AMOUNT";
})(ForecastAmountSettingOptions || (ForecastAmountSettingOptions = {}));
export const FORECAST_STRATEGY_DEAL_PROPERTIES_FMO_GATED = {
  [ForecastAmountSettingOptions.TOTAL_AMOUNT]: 'amount_in_home_currency',
  [ForecastAmountSettingOptions.WEIGHTED_AMOUNT]: 'hs_projected_amount_in_home_currency',
  [ForecastAmountSettingOptions.FORECAST_AMOUNT]: 'hs_forecast_amount'
};
export const FORECAST_STRATEGY_DEAL_PROPERTIES = {
  [ForecastAmountSettingOptions.TOTAL_AMOUNT]: 'dealAmount',
  // For this setting, API provides us with
  // the forecast type amount property * deal probability
  [ForecastAmountSettingOptions.WEIGHTED_AMOUNT]: 'weightedDealAmount',
  // For this setting, API provides us with
  // the forecast type amount property * forecast probability
  [ForecastAmountSettingOptions.FORECAST_AMOUNT]: 'weightedDealAmount'
};